"use strict";
(function (global) {

  var TEMPLATE = {
    LAYOUT: 'layouts/FormDialog.compile.html'
  };

  /**
  * Диалог для работы с формами.
  * @class WebAccess.components.dialogs.FormDialog
  * @extends WebAccess.components.dialogs.BaseDialog
  * @mixes WebAccess.mixins.formMixin
  * @property {Deferred} Init меняет сосотояние при инициализации элементов управления формы
  * @property {Object} model переданная в конструктор модель  
  * @property {String} serviceURL адрес веб-сервиса обслуживающего диалог
  * @since 5.2.0.1600  
  */
  var FormDialog = global.CMP.dialogs.BaseDialog.extend([global.mixins.formMixin], {
    className: 'FormDialog',
    model: null,
    width: 1000,
    height: 'auto',
    dialogClass: 'form-dialog-content-padding', //если нужно будет поменять padding или убрать его, то не забыть поменять внизу размер этого padding.
    serviceURL: "/Dialogs.asmx",
    modalWindowButtons: null,

    _pendingOperations: null,
    _containerInit: null,
    _detailsGridInit: null,
    _keepAliveTimer: null,
    _sideBarContainerSelector: '.twc_left',
    _freeAfterClosing: true,
    //-----------------------------------------------------------------------//    

    init: function (settings, model) {
      var me = this;
      if (!model) WA.raise(L("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED"));
      me.model = model;
      me._pendingOperations = {};

      me._preInit();

      me._keepAliveTimer = {
        timeout: null
      };

      me._containerInit = $.Deferred();
      me._detailsGridInit = $.Deferred();

      me._super(settings);

      me.id = me.model.InstanceID;
      me._postInit();
      me._keepAlive();

      me.bind(me['class'].EVENT.AFTER_CLOSE, $.proxy(me._freeDialog, me));
      return this;
    },
    //-----------------------------------------------------------------------//

    // Инициализация objectList.
    _initObjectList: function () {
      var me = this;
      me.objectList = new global.CMP.wrappers.objectList.ObjectList(me.containerSelector);
    },

    /**
    * Отобразить диалоговое окно
    * @method WebAccess.components.dialogs.FormDialog#show
    * @param {object} [showParams] Параметры показа диалога.
    * @param {bool} [showParams.freeAfterClosing] TRUE - если нужно освободить серверный объект диалога после закрытия, иначе - FALSE.
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    show: function (showParams = {}) {
      var me = this;
      var baseShow = me._super; //_beforeShow асинхронный, поэтому _super уже удалится после выполнения метода, сохраняем его чтобы вызвать.
      if (showParams.freeAfterClosing !== undefined)
      {
        //по умолчанию мы всегда освобождаем диалог после закрытия. Но иногда требуется отложить освобождение. 
        this._freeAfterClosing = showParams.freeAfterClosing;
      }

      me._beforeShow().done(function () {
        baseShow.apply(me); //если вызвать без apply то this будет равен window.
        me._afterShow();
      });

      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Запуск таймера для поддержания объекта диалога
    * @method WebAccess.components.dialogs.FormDialog#_keepAlive
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _keepAlive: function () {
      var me = this;
      if (!LockUpdateTime) {
        log.warn('DEPRECATION', 'Call to global variable "LockUpdateTime" failed');
        return;
      }
      me._keepAliveTimer = setTimeout(function () {
        WA.SRV.call(me.serviceURL + '/KeepAlive', {
          InstanceID: me.id
        }).always(function () {
          me._keepAlive();
        });
      }, LockUpdateTime);
      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Получить модель объекта связанного с текущим диалогом
    * @method WebAccess.components.dialogs.FormDialog#_keepAlive
    * @private
    * @return {String} минимальная модель объекта формы в виде JSON
    */
    _getObjectLink: function () {
      var me = this;
      return $.toJSON({
        'InstanceID': me.id
      });
    },
    //-----------------------------------------------------------------------//

    /**
    * Получить представление
    * @method WebAccess.components.dialogs.FormDialog#_getObjectView
    * @private
    * @return {String} код представления
    */
    _getObjectView: function () {
      return '';
    },
    //-----------------------------------------------------------------------//

    _registerOperation: function (name, operation) {
      this._pendingOperations[name] = operation;
    },
    //-----------------------------------------------------------------------//

    _unRegisterOperation: function (name) {
      delete this._pendingOperations[name];
    },
    //-----------------------------------------------------------------------//

    /**
    * Получить информацию о форме
    * @method WebAccess.components.dialogs.FormDialog#_getFormData
    * @private
    * @return {String} модель формы в виде JSON
    */
    _getFormData: function () {
      var me = this;
      return $.parseJSON(me.model['FormData']);
    },
    //-----------------------------------------------------------------------//

    /**
    * Получить экземпляры объектов грида
    * @method WebAccess.components.dialogs.FormDialog#_getGrids
    * @private
    * @return {Array<WebAccess.components.dataViews.Grid>} экземпляры гридов
    */
    _getGrids: function () {
      var me = this;
      return me.grids;
    },
    //-----------------------------------------------------------------------//

    /**
     * Создание html разметки и контейнеров
     *
     * @method WebAccess.components.dialogs.FormDialog#_beforeShow
     * @private
     * @return {Deferred<void>}
     */
    _beforeShow: function () {
      var me = this;
      me.containerSelector = "div#dialog_content_" + me.id;
      me.modalWindowButtons = [];
      me.isShowOkButton = false;

      var state = $.Deferred();
      me.width = +(me.model.Width || me.width) + 20; //20 - padding указанный в CSS .form-dialog-content-padding

      //inlineHint плохо работает с фиксированной высотой, поэтому строку ниже закоментировал.
      //me.height = me.model.Height || me.height; 
      me.title = me.model.Caption || me.title;

      if (!me.model['TabsHtml']) {
        me.html = me.model['FormHtml'];
        state.resolve();
        return state;
      }

      me.height = me.model.Height || me.height;
      me.width += 75; //Ширина табов      

      WA.templates.render(TEMPLATE.LAYOUT, {
        left: me.model['TabsHtml'],
        right: me.model['FormHtml']
      }).done(function (html) {
        me.html = html;
        state.resolve();
      })

      return state;
    },
    //-----------------------------------------------------------------------//

    /**
    * Иницииализация jQuery объектов и навешивание на них событий, 
    * функция вызывается когда модальное окно и все его элементы загружены.
    * @method WebAccess.components.dialogs.FormDialog#_afterShow
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _afterShow: function () {
      var me = this;
      me._containerInit.resolve();
      me._fixStyles();
      me._initActions();

      if (!!me.model['TabsHtml']) me._initTabs();
      me._initDetails();
      return me;
    },
    //-----------------------------------------------------------------------//   

    /**
    * Подгонка стилей, чтобы ничего не выпирало.    
    * @method WebAccess.components.dialogs.FormDialog#_fixStyles
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _fixStyles: function () {
      var me = this;
      var isAnySelected = me.sideBar.tabs.toArray().some(function (tab) {
        if (!isAnySelected && tab.isVisible()) {
          tab._jObject.addClass('selected');
          return true;
        }
        return false;
      });
      if (!isAnySelected) me._jContent.find('.tab_item.first').addClass('selected');
      if (!InitHoverForButtons) {
        log.warn('DEPRECATION', 'Call to global variable "InitHoverForButtons" failed');
        return;
      }

      $('.CardForm').redraw(); //#106605
      InitHoverForButtons();
      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Инициализация прикладных действий. Навешивание обработчиков на кнопки и ссылки.
    * @method WebAccess.components.dialogs.FormDialog#_initActions
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _initActions: function () {
      var me = this;
      if (me.model && me.model.hasOwnProperty('Actions')) {
        var actions = $.parseJSON(me.model.Actions);
        var buttons = me.form.controls.buttons.toArray();
        var links = me.form.controls.links.toArray();
        me._initActionItems(buttons, actions);
        me._initActionItems(links, actions);
        me.bind(me['class'].EVENT.BEFORE_CLOSE_BY_CROSS, function () {
          me._executeDefaultAction(DIALOG_ACTION.CANCEL);
          return false;
        }).bind(me['class'].EVENT.BEFORE_CLOSE_BY_ESCAPE, function () {
          me._executeDefaultAction(DIALOG_ACTION.CANCEL);
          return false;
        });
      }
      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Именно здесь кнопки и ссылки с действиями становятся активными и получают
    * свои заголовки
    * @param {Array<BasePageElement>} items компоненты
    * @param {Object} actions действия
    * @method WebAccess.components.dialogs.FormDialog#_initActionItems
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _initActionItems: function (items, actions) {
      var me = this;
      _(items).each(function (item) {
        var action = _(actions).findWhere({ Name: item.actionName });
        if (action) {
          item.bind('click', function () {

            //#106918
            if (!action.Description.HasChangeEventHandler && item.actionName !== DIALOG_ACTION.OK) {
              // Не передаем результат, что бы диалог не закрылся, но при "Отмене" нужно закрыть в любом случае. #107380
              return me._handleAction(name, item.actionName === DIALOG_ACTION.CANCEL ? 2 : undefined);
            }

            var process = $.proxy(me._executeDefaultAction, me);
            if (me.fire(FormDialog.EVENT.BEFORE_ACTION, item.actionName, action, me) === false) {
              return;
            };
            process(item.actionName);
          });

          if (!item.getLabel()) item.setLabel(action.Description.Caption);
          item.setTooltip(action.Description.Hint);
          if (!action.Description.IsEnabled) {
            item.disable();
          }
          if (!action.Description.IsVisible) {
            item.hide();
          }
        }
      });

      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Запуск действия "по умолчанию". Т.е. когда обработкой занимается сервер, 
    * а клиент только говорит какое действие надо вызвать и передает данные формы.
    * свои заголовки.
    * @param {string} name имя действия    
    * @method WebAccess.components.dialogs.FormDialog#_executeDefaultAction
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _executeDefaultAction: function (name) {
      var me = this;
      me.form._unHighlightRequisites();
      if (me.fire(FormDialog.EVENT.BEFORE_ACTION, name, me) === false) return me;

      //#106428
      if (name === DIALOG_ACTION.CANCEL) {
        me._handleAction(name, 2); //аналогично билдеровскому mrCancel=2
        return me;
      }
      // HACK для сохранения изменения в детальных разделах, если после изменения сразу сохранять карточку без клика куда-то в друое место грида.
      var allGrids = me.grids;
      for (var gridName in allGrids) {
        var grid = allGrids[gridName].grid;
        var cell = grid.getActiveCell();
        if (cell) {
          grid.navigateUp();
        }
      }

      WA.SRV.call(me.serviceURL + '/ExecuteAction', {
        DialogInstanceID: me.id,
        ActionName: name,
        Req: me.form._getRequisitesToSend(me.form),
        Cmd: $.toJSON(me.form._commandList)
      }, null, null, true).done(function (response) {
        var responseAsObject = $.parseJSON(response);

        //скрываем сообщения о предыдущих ошибках, если были
        $.when(WA.FormControlsInit).then(() => {
          WA.CMP.NTF.InlineHint.hideAll();
        });      

        // Обрабатываем изменения реквизитов действием.
        var changes = responseAsObject.Changes;
        var changedMultiSelects = responseAsObject.ChangedMultiSelectRequisitesValues;
        me.form.applyServerSideChanges(changes, changedMultiSelects);

        // Обрабатываем результат выполнения действия.
        var result = responseAsObject.Result;
        me._handleAction(name, result);

      }).fail(function (err, response) {
        me.form._handleFailSave(this, true, null, me.details, me.inlineHint);

        // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
        if (response && response.Result) {
          var data = $.parseJSON(response.Result);
          // Обрабатываем изменения реквизитов действием.
          var changes = data.Changes;
          var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
          me.form.applyServerSideChanges(changes, changedMultiSelects);
        }
      });
      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Пост-обработка действия
    * @param {string} name имя действия    
    * @param {object} result результат выполнения
    * @method WebAccess.components.dialogs.FormDialog#_handleAction
    * @private
    * @return {String} JSON объект с реквизитами
    */
    _handleAction: function (name, result) {
      var me = this;
      var preventClose = (me.fire(FormDialog.EVENT.AFTER_ACTION, name, result, me) === false);

      // 0 - когда нажимаем на не стандартную кнопку с custom-действием.
      // Вычислений на действии нет. Возвращается 0. В билдере окно не закрывается.
      // Мы тоже не будем.
      // См. #106093
      if ((result && result != 0) && !preventClose) {
        me.close();
      }
      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Поддержка работы табов
    * @method WebAccess.components.dialogs.FormDialog#_initTabs
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _initTabs: function () {
      var me = this;
      me.sideBar.setOrientation(ORIENTATION.VERTICAL);
      var jTabs = me._jContent.find('.twc_right .CardForm_Tab');

      // Получить выбранную вкладку
      var activeTabDfmName = $('.tab_item.selected').data('name');
      jTabs.filter('[data-dfm-name=' + activeTabDfmName + ']').show();
      me._jContent.find('.tab_item').not('.more').on('click', function () {
        var tabName = $(this).data('name');

        //TODO Шамов А.: События должны fire внутри класса, а не где попало.
        me.sideBar.fire(me.sideBar['class'].EVENT.BEFORE_TAB_SWITCH, me.sideBar.tabs[tabName]);

        jTabs = me._jContent.find('.twc_right .CardForm_Tab');
        me._jContent.find('.tab_item.selected').removeClass('selected');
        $(this).addClass('selected');
        jTabs.hide();
        jTabs.filter('[data-dfm-name="' + tabName + '"]').show();

        //TODO Шамов А.: События должны fire внутри класса, а не где попало.
        me.sideBar.fire(me.sideBar['class'].EVENT.AFTER_TAB_SWITCH, me.sideBar.tabs[tabName]);
      });

      if (!me._isFitted) {
        me._jDialog.dialog("option", "height", 'auto');
      };
      me._jContent.find('input[type="text"], textarea').not('.Req_Disabled').first().focus().select(); //#106799
      $('.CardForm').redraw(); //#106605
      return me;
    },
    //-----------------------------------------------------------------------//

    /**
    * Поддержка работы детальных разделов
    * @method WebAccess.components.dialogs.FormDialog#_initDetails
    * @private
    * @return {WebAccess.components.dialogs.FormDialog}
    */
    _initDetails: function () {
      var me = this;
      var Initiializer = WebAccess.components.wrappers.details.DetailsInitiializer;

      var DataProviderClass = global.components.dialogs.FormDialogDataProvider;
      var dataProviderOptions = {
        "DialogName": me.model.Name,
        "InstanceID": me.model.InstanceID
      };

      var detailsInitiializer = new Initiializer(me._jContainer.selector + ' div.Reference_Detail',
                                                 DataProviderClass,
                                                 dataProviderOptions,
                                                 WA.components.dataViews.gridPlugins.DetailsContextMenu, me);
      detailsInitiializer.bind(Initiializer.EVENT.COMPLETE, function (initiializer) {
        me.grids = initiializer.gridInstances;
        initiializer.waitForData().done(function () {
          me._detailsGridInit.resolve();
        });
      });

      $.when(me.states.form, me.states.tables).then(function () {
        if (!me.form.isExist()) return;

        // Логика работы ведущих/ведомых в дательных разделах.
        me.bindLeaderDrivenLogic();

        //Удаляем пустые строки перед сохранением
        me.form.bind("prepareSave", function removeEmptyRows() {
          for (var tableName in me.form.controls.tables) {
            var table = me.form.controls.tables[tableName];
            var rows = table.rows.toArray();
            var lastRow = rows[rows.length - 1];

            if (rows.length && lastRow && !lastRow.hasFilledRequisites() && !lastRow._locked) {
              table.deleteRow(lastRow.getRowId(), true);
            }
          }
        });
      });
    },
    //-----------------------------------------------------------------------//

    /**
    * Получить высоту диалога
    * @private
    */
    _getAvailableHeight: function () {
      return this.model.Height;
    },

    /**
     * Освободить серверный объект API при закрытии диалога.
     * setTimeout используется, потому что грид инициализируется асинхронно,
     * и запросы могут посыпаться позже, чем мы сделаем freeDialog.
     * @method WebAccess.components.dialogs.FormDialog#_freeDialog     
     * @private
     * @return {WebAccess.components.dialogs.FormDialog}
     */
    _freeDialog: function () {
      var me = this;

      if (me._freeAfterClosing) {
        setTimeout(function () {
          clearTimeout(this._keepAliveTimer);
          _(me.grids).each(function (grid, name) {
            clearTimeout(grid._queryDelay);
          })
          _(me._pendingOperations).each(function (operation, name) {
            operation.abort();
          });
          WA.SRV.call(me.serviceURL + '/FreeDialog', {
            InstanceID: me.id
          });
        }, 300);
      }

      return me;
    },

    /**
     * Выполняет прикладной метод.
     *
     * @method FormDialog.executeEntityMethod
     * @param {string} methodName Имя прикладного метода.
     * @param {Array<Object>} opt_parameters Параметры, с которыми должен вызываться прикладной метод.
     * @return {Deferred<Object>} Результат выполнения прикладного метода.
     * @since 5.5.0.1000
     * @see https://api.jquery.com/category/deferred-object/
     *
     * @example 
     * WebAccess.current.executeEntityMethod('MethodName', new WA.Link()).done(function(result) { console.log(result); });
     */
    executeEntityMethod: function (methodName, opt_parameters) {
      var d = $.Deferred();
      var me = this;
      var parameters = Array.prototype.slice.call(arguments, 1);

      WA.domainMethods.executeEntityMethod("/api/Dialog.asmx/ExecuteEntityMethod",
        this.id, "", methodName, parameters).done(function (res) {
          var changes = res.Changes;
          var changedMultiSelects = res.ChangedMultiSelectRequisitesValues;
          if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);

          d.resolve(res.MethodResult);
        }).fail(function (errorMessage, res) {
          if (res) {
            if (res.Result) {
              var data = res.Result;
              var changes = data.Changes;
              var changedMultiSelects = data.ChangedMultiSelectRequisitesValues;
              if (me.form && me.form.isExist()) me.form.applyServerSideChanges(changes, changedMultiSelects);
            }
            d.reject(res.Error);
          } else {
            d.reject(errorMessage);
          }
        });

      return d.promise();
    },

    /**
     * Проверяет, доступен ли прикладной метод для текущего диалога.
     * @function FormDialog.isMethodAvailable
     * @param {string} methodName Имя прикладного метода.
     * @return {boolean} true, если метод доступен для текущего диалога, иначе false.
     * @since 5.5.0.1000
     */
    isMethodAvailable: function (methodName) {
      return WA.domainMethods.isMethodAvailable("/api/Dialog.asmx/IsEntityMethodAvailable", this.id, methodName);
    }


    //-----------------------------------------------------------------------//

  }, {
    EVENT: $.extend({
      /**
      * Срабатывает перед началом выполнения действия. 
      * Можно остановить запуск действия "по умолчанию" возвратив false в обработчике события.
      * Затем можно продолжить запуск действия "по умолчанию" взывав функцию action.
      * @event WebAccess.components.dialogs.FormDialog.EVENT.BEFORE_ACTION
      * @param {string} actionName имя действия
      * @param {function} action действие по умолчанию
      * @param {WebAccess.components.dialogs.FormDialog} dialog экземпляр диалога
      */
      BEFORE_ACTION: 'beforeAction',

      /**
      * Срабатывает после выполнения действия.     
      * Можно предотвратить закрытие диалога, возвратив false в обработчике события.
      * @event WebAccess.components.dialogs.FormDialog.EVENT.AFTER_ACTION
      * @param {string} actionName имя действия
      * @param {object} result результат выполнения действия. Данные которые возвращает сервер.
      * @param {WebAccess.components.dialogs.FormDialog} dialog экземпляр диалога
      */
      AFTER_ACTION: 'afterAction'
    }, global.components.dialogs.BaseDialog.EVENT)
  });

  //-------------------------------------------------------------------------//

  global.components.dialogs.FormDialog = FormDialog;
})(window.WebAccess);